import { render } from "./RenderingRandselBack.vue?vue&type=template&id=519dfd19&ts=true"
import script from "./RenderingRandselBack.vue?vue&type=script&lang=ts"
export * from "./RenderingRandselBack.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__